export type MicroAnimType =
    | "kick"
    | "pick-me-up"
    | "staple"
    | "dog"
    | "power-up"
    | "pulse"
    | "wrap";

export function animateWord(
    el: HTMLElement,
    type: MicroAnimType,
    tl: gsap.core.Timeline,
) {
    switch (type) {
        case "kick":
            tl.to(el, {
                rotate: "-20deg",
                y: -8,
                scale: 1.1,
                duration: 0.25,
                ease: "power2.out",
            });
            tl.to(el, {
                rotate: 0,
                y: 0,
                scale: 1,
                duration: 0.35,
                ease: "elastic.out(1, 0.4)",
            });
            break;
        case "pick-me-up":
            tl.to(el, {
                y: -12,
                duration: 0.2,
                ease: "power2.out",
            });
            tl.to(el, {
                y: 0,
                duration: 0.25,
                ease: "bounce.out",
            });
            break;
        case "staple":
            tl.to(el, {
                scaleX: 1.1,
                scaleY: 0.9,
                rotation: -3,
                transformOrigin: "50% 50%",
            });
            tl.to(el, {
                scaleX: 0.9,
                scaleY: 1.05,
                rotation: 2,
                duration: 0.15,
                ease: "power3.in",
            });
            tl.to(el, {
                scaleX: 1,
                scaleY: 1,
                rotation: 0,
                duration: 0.2,
                ease: "power2.out",
            });
            break;
        case "dog":
            tl.to(el, {
                rotation: -6,
                transformOrigin: "50% 50%",
            });
            tl.to(
                el,

                {
                    rotation: 6,
                    duration: 0.08,
                    yoyo: true,
                    repeat: 3,
                    ease: "sine.inOut",
                },
            );
            tl.to(el, {
                rotation: 0,
                duration: 0.2,
                ease: "power2.out",
            });
            break;
        case "power-up":
            tl.to(el, {
                scale: 0.9,
                duration: 0.1,
                textShadow: "0 0 0 rgba(56,189,248,0)",
            });
            tl.to(
                el,

                {
                    scale: 1.05,
                    duration: 0.75,
                    ease: "power2.out",
                    textShadow: "0 0 12px rgba(56,189,248,0.9)",
                },
            );
            tl.to(el, {
                scale: 1,
                duration: 0.25,
                ease: "elastic.out(1, 0.5)",
                textShadow: "0 0 0 rgba(56,189,248,0)",
            });
            break;
        case "pulse":
            tl.to(el, {
                scale: 1.2,
                duration: 0.2,
                ease: "power1.out",
            });
            tl.to(el, {
                scale: 1,
                duration: 0.25,
                ease: "power2.inOut",
            });
            break;
        case "wrap":
            tl.to(el, {
                scaleY: 1.2,
                scaleX: 0.8,
                transformOrigin: "50% 50%",
            });
            tl.to(el, {
                scaleY: 0.85,
                scaleX: 1.1,
                duration: 0.18,
                ease: "power2.in",
            });
            tl.to(el, {
                scaleX: 1,
                scaleY: 1,
                duration: 0.22,
                ease: "elastic.out(1, 0.5)",
            });
            break;
        default:
            break;
    }
}
